import { render, staticRenderFns } from "./whatsapp-tool.html?vue&type=template&id=2e68cb50&scoped=true&"
import script from "./whatsapp-tool.js?vue&type=script&lang=js&"
export * from "./whatsapp-tool.js?vue&type=script&lang=js&"
import style0 from "./whatsapp-tool.scss?vue&type=style&index=0&id=2e68cb50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68cb50",
  null
  
)

export default component.exports